import React, { useContext, useState } from "react";

//internal import
import { SidebarContext } from "context/SidebarContext";
import AgentsServices from "services/AgentsServices";
import { notifySuccess } from "utils/toast";
import ConfirmAgentModal from "components/form/ConfirmAgentModal";
import { FiEdit } from "react-icons/fi";

const ShowAgentStatus = ({ id, status }) => {
  const { setIsUpdate, setFunctionLoading } = useContext(SidebarContext);
  const [showActiveModal, setShowActiveModal] = useState(false);
  const [nextStatus, setNextStatus] = useState(null);
  const [requireRemark, setRequireRemark] = useState(false);

  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const id_employee = adminInfo?.id ? adminInfo.id : 0;
  
  const handleChangeStatus = () => {
    let newStatus = 0;
    let needRemark = false;

    // 1 = Active, 0 = Inactive, 2 = Blocked
    if (status === 1) {
      newStatus = 0;
      needRemark = true;
    } else if (status === 0 || status === 2) {
      newStatus = 1;
      needRemark = false;
    }

    setNextStatus(newStatus);
    setRequireRemark(needRemark);
    setShowActiveModal(true);
  };

  const handleUpdateStatus = async (remark, goStatus) => {
    setShowActiveModal(false);
    setFunctionLoading(true);
    const updateData = {
      status: Number(goStatus),
      remark: remark,
      action_by: id_employee,
    };

    const res = await AgentsServices.updateAgentsStatus(id, updateData);

    setIsUpdate(true);
    setFunctionLoading(false);
    notifySuccess(res.message);
  };
  return (
    <>
      <span
        className="text-sm  cursor-pointer  focus:outline-none"
        style={{ color: "blue", fontSize: "11px" }}
        onClick={() => handleChangeStatus(id)}
      >
        Change
      </span>
      <ConfirmAgentModal
        isOpen={showActiveModal}
        status={status.toString()}
        nextStatus={nextStatus?.toString()}
        requireRemark={requireRemark}
        onClose={() => setShowActiveModal(false)}
        onConfirm={handleUpdateStatus}
      />
    </>
  );
};

export default ShowAgentStatus;
